module.exports = __webpack_public_path__ + "img/img-redtiger-d.a884c53f.png";